import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth as useClerkAuth, useUser, useClerk } from "@clerk/clerk-react";
import { registerAuthInterceptor } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const { getToken, isLoaded: authLoaded } = useClerkAuth();
  const { isLoaded: userLoaded, isSignedIn, user: clerkUser } = useUser();
  const { signOut } = useClerk();
  const [ready, setReady] = useState(false);

  // Attach Clerk token to all API requests.
  useEffect(() => {
    if (authLoaded) {
      registerAuthInterceptor(getToken);
      setReady(true);
    }
  }, [authLoaded, getToken]);

  let user = null; // null = loading, false = signed out, object = signed in
  if (userLoaded && ready) {
    user = isSignedIn
      ? {
          id: clerkUser.id,
          email: clerkUser.primaryEmailAddress?.emailAddress || "",
          name: clerkUser.fullName || clerkUser.username || "",
        }
      : false;
  }

  const logout = async () => {
    await signOut();
  };

  return <AuthCtx.Provider value={{ user, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
